import { ReAcceptConfirmModalReducerState } from './types';

export const getDefaultState = (): ReAcceptConfirmModalReducerState => ({
  isOpened: false
});
